<template>
    <div class="d-flex flex-column justify-center align-center">
        <v-card-title data-cy="question-counterStep-title" class="text-justify primary--text text-h5 px-3 py-2 w-100">
            <div class="icon mr-2 d-flex justify-center">
                <v-icon color="primary" large>mdi-help-circle</v-icon>
            </div>
            {{
                `${$t('initialTour.question')} ${question_number} ${$t(
                    'initialTour.of'
                )} ${count_question}`
            }}
        </v-card-title>
        <v-row align="center" justify="center" class="px-5 mb-2 mt-2 diagnostic-question w-100">
            <span class="text-body-1 primary--text text-justify font-weight-regular px-3 w-100">
                {{ data.contenido }}
            </span>
            <v-row data-cy="question-containerAnswers" class="w-100 ma-0 pa-0" align="center" justify="center">
                <v-col
                    cols="12"
                    v-for="answer of data.respuestas"
                    :key="answer.id"
                    v-ripple
                    :class="classSelected(answer.id)"
                    @click="setSelectedBtn(answer.id)"
                    elevation="0"
                >
                    {{ $utils.capitalizeWord(answer.contenido) }}
                </v-col>
            </v-row>
        </v-row>
    </div>
</template>
<script>
export default {
    props: {
        data: { type: Object, default: null },
        question_number: { type: [Number, String], default: 0 },
        count_question: { type: [Number, String], default: 0 },
        cleanSelection: { type: Number, default: 0 },
    },
    data() {
        return {
            btnSelected: null,
        }
    },
    methods: {
        classSelected(btnNumber) {
            const colorText = btnNumber === this.btnSelected ? 'white--text' : 'primary--text'
            return `w-100 my-3 transition-all cursor-pointer pa-2 border-radius-1 text-none option-btn ${colorText} ${this.bgColor(
                btnNumber
            )}`
        },
        bgColor(btnNumber) {
            return btnNumber === this.btnSelected ? 'primary' : 'white'
        },
        setSelectedBtn(btnNumber) {
            this.btnSelected = btnNumber
            this.$emit('newSelection', btnNumber)
        },
    },
    watch: {
        cleanSelection() {
            this.btnSelected = null
        },
    },
}
</script>

<style scoped>
.diagnostic-question {
    height: 40vh;
    overflow: auto;
}
.icon {
    border-radius: 500px;
}

.icon i {
    font-size: 24px;
    font-weight: bolder;
}

.option-btn {
    border: thin solid;
    border-color: #514773 !important;
    font-size: 0.9rem;
    max-width: 100%;
}
</style>
